import { Tab, Tabs } from '@material-ui/core';
import React from 'react';
import TabPane from './tabPane';

type Tabs = {
  name: string | undefined | null;
  id: string | undefined | null;
};

interface IScrollAbleTabsProps {
  tabs: Tabs[];
  onChange?: (index: number) => void;
  tabIndex: number;
}

const ScrollAbleTabs: React.FC<IScrollAbleTabsProps> = ({ tabs, onChange, tabIndex }) => {
  const handleChange = (event: any, newValue: number) => {
    if (onChange) onChange(newValue);
  };
  return (
    <div className="root">
      <Tabs value={tabIndex} onChange={handleChange} variant="scrollable" scrollButtons="auto">
        {tabs.map((item, index) => {
          return (
            <Tab
              label={<TabPane tab={item.name || ''} active={index === tabIndex} />}
              key={index}
            />
          );
        })}
      </Tabs>
      <style jsx>{`
        .root {
          width: 100%;
          :global(.MuiTouchRipple-root) {
            display: none;
          }
          :global(.PrivateTabIndicator-root-1) {
            display: none;
          }
          :global(.MuiTab-textColorInherit) {
            opacity: 1;
          }
          :global(.MuiTab-root) {
            text-transform: none !important;
            padding: 0 !important;
            min-width: auto !important;
            max-width: 1000px !important;
            margin-right: 12px;
          }
          :global(.MuiTabs-root) {
            position: relative;
          }
          :global(.MuiTabScrollButton-root:nth-child(1)) {
            position: absolute;
            top: 0;
            left: 0;
            background-image: linear-gradient(to right, #fff 24%, rgba(255, 255, 255, 0));
            z-index: 50;
            height: 100%;
          }
          :global(.MuiTabScrollButton-root:nth-last-child(1)) {
            position: absolute;
            top: 0;
            right: 0;
            background-image: linear-gradient(to left, #fff 24%, rgba(255, 255, 255, 0));
            z-index: 50;
            height: 100%;
          }
          :global(.MuiSvgIcon-root) {
            border-radius: 50%;
            width: 24px;
            height: 24px;
            box-shadow: 0 2px 8px 0 rgba(51, 53, 50, 0.16);
          }
          :global(.MuiTabs-scrollButtonsDesktop) {
            display: inline-flex;
          }
          :global(.MuiTabs-indicator) {
            background: none;
          }
        }
        @media screen and (max-width: 768px) {
          .root {
            :global(.MuiTabScrollButton-root) {
              width: 28px;
            }
          }
        }
      `}</style>
    </div>
  );
};

export default ScrollAbleTabs;
